import * as cons from './constants';
import * as apis from './apis';
import { requestActionMaker } from '../helper';

export const getAllInvoice = para => requestActionMaker({ cons: cons.GET_ALL_INVOICE, api: apis.getAllInvoice, ...para });
export const getInvoice = para => requestActionMaker({ cons: cons.GET_INVOICE, api: apis.getInvoice, ...para });
export const getInvoiceByHashInvoiceNumber = para => requestActionMaker({ cons: cons.GET_INVOICE_BY_HASH_INVOICE_NUMBER, api: apis.getInvoiceByHashInvoiceNumber, ...para });
export const postCreateInvoice = para => requestActionMaker({ cons: cons.POST_CREATE_INVOICE, api: apis.postCreateInvoice, ...para });
